// extracted by mini-css-extract-plugin
export var avatarContainer = "_58-0";
export var avatarTypingWave = "_58-i";
export var gray = "_58-f";
export var green = "_58-c";
export var icon = "_58-9";
export var image = "_58-1";
export var lg = "_58-6";
export var md = "_58-5";
export var presenceDot = "_58-b";
export var red = "_58-d";
export var sm = "_58-4";
export var status = "_58-a";
export var typingDot = "_58-h";
export var typingPill = "_58-g";
export var xl = "_58-7";
export var xs = "_58-3";
export var xxl = "_58-8";
export var xxs = "_58-2";
export var yellow = "_58-e";